import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

export function ProjectsListLogic({ render }) {
    const [projects, setProjects] = useState([]);

    useEffect(() => {
        const loadProjects = async () => {
            try {
                const res = await axios.get("/api/public/projects");
                setProjects(res.data.content || []);
            } catch (err) {
                toast.error("Error loading projects");
            }
        };

        loadProjects();
    }, []);

    return render({ projects });
}
